import { InputResolution, PipelineName, SegmentationBackend, SegmentationModel } from "./segmentationHelper";

export class VirtualBGModel {
  private model: SegmentationModel;
  private isSIMDSupported: boolean;
  private backend: SegmentationBackend;
  private inputResolution: InputResolution;
  private pipeline: PipelineName;
  constructor(model: SegmentationModel, isSIMDSupported: boolean, backend: SegmentationBackend) {
    this.model = model;
    this.isSIMDSupported = isSIMDSupported;
    this.backend = backend;
    this.inputResolution = '640x360';
    this.pipeline = 'canvas2dCpu';
  }
  getResolutionDetails() {
    switch (this.model) {
    case 'bodyPix':
      this.backend = 'webgl';
      this.inputResolution = '160x96';
      this.pipeline = 'canvas2dCpu';
      break;
    case 'meet':
      if (
        (this.backend !== 'wasm' && this.backend !== 'wasmSimd') ||
          (this.inputResolution !== '256x144' && this.inputResolution !== '160x96')
      ) {
        this.backend = this.isSIMDSupported ? 'wasmSimd' : 'wasm';
        this.inputResolution = '160x96';
        this.pipeline = 'webgl2';
      }
      break;
    case 'mlkit':
      if (
        (this.backend !== 'wasm' && this.backend !== 'wasmSimd') ||
        this.inputResolution !== '256x256'
      ) {
        this.backend = this.isSIMDSupported ? 'wasmSimd' : 'wasm';
        this.inputResolution = '256x256';
        this.pipeline = 'webgl2';
      }
      break;

    }
    return {
      model: this.model,
      backend: this.backend,
      inputResolution: this.inputResolution,
      pipeline: this.pipeline
    };
  }
}



